import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/App.vue'
import Personal from './personal.js'
import helpCenter from './helpCenter.js'
import StudentManage from "./studentManage.js";
import Grouping from './grouping.js'
import ClassList from "./classList";
import OrgManage from "./orgManage.js";
import courseIssuance from './courseIssuance.js'
import testPaperMange from './testPaperManage.js'
import studyProgress from './studyProgress.js'
import examManage from "./examManage.js";
import courseManage from './courseManage.js'
import noticeManage from './noticeManage.js'
import settingManage from './settingManage.js'
import RolePermissions from './rolePermissions.js'
import testPaperManages from "./testPaperManages.js";
import certificateManages from "./certificate";
import completionCertificates from './completionCertificates';
import merchandiseManage from './merchandiseManage'
import allocation from './allocation'
import atomicClasses from './atomicClasses'
import audit from './audit'
import coursePackage from './coursePackage'
import courseTypeManage from './courseTypeManage'
import examinationPaper from './examinationPaper'
import knowledge from './knowledge'
import permissionManage from './permissionManage'
import skillsLabel from './skillsLabel'
import teachMarkManage from './teachMarkManage'
import testBaseManage from './testBaseManage'
import souceManage from './souceManage'
import Common from './common.js'
import ResourcesManage from './resourcesManage'
import ThreePartyTest from './threePartyTest'
import ThreePartyBusiness from './threePartyBusiness'
import Classification from "./classification";

Vue.use(Router);


const routes = [
  {
  path: '/',
  component: Layout,
  children: [
    {
    path: '/',
    name: 'Dashboard',
    meta: {
      title: '首页',
      keepAlive: true
    },
    component: resolve => require(['@/views/home/Index.vue'], resolve),
  },
    Personal,
    helpCenter,
    Grouping,
    testPaperManages,
  ]
  },
  allocation,
  atomicClasses,
  audit,
  coursePackage,
  courseTypeManage,
  examinationPaper,
  knowledge,
  permissionManage,
  skillsLabel,
  teachMarkManage,
  testBaseManage,
  souceManage,
  ResourcesManage,
  ThreePartyTest,
  ThreePartyBusiness,
  Classification,
  StudentManage,
  ClassList,
  OrgManage,
  merchandiseManage,
  courseIssuance,
  testPaperMange,
  studyProgress,
  examManage,
  courseManage,
  noticeManage,
  settingManage,
  RolePermissions,
  certificateManages,
  completionCertificates,
  {
    path: '/forget_password',
    name: 'ForgetPassword',
    meta: {
      title: '忘记密码',
      keepAlive: false
    },
    components:{blank:resolve => require(['@/views/forgetPassword/Index.vue'], resolve)}
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: '后台登录',
      keepAlive: false
    },
    components: {
      blank: resolve => require(['@/views/login/Login.vue'], resolve),
    }
  },
  {
    path: '*',
    redirect: '/',
  },
];

export default new Router({
  routes
})
